<template>
  <div class="animate__animated animate__fadeIn">
    <HistoryQrCodes />
  </div>
</template>

<script>
import HistoryQrCodes from "@/components/history/HistoryQrCodes.vue";
export default {
  components: { HistoryQrCodes },
};
</script>

<style></style>
